import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-final-form';
import { addSegment } from '@websky/core/src/SearchForm/store/segments/actions';
import Button from '@websky/core/src/Button';
import css from './Actions.css';
const PlusIcon = (React.createElement("svg", { width: "31", height: "30", viewBox: "0 0 31 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("circle", { cx: "15", cy: "15", r: "14", stroke: "#BB2649", strokeWidth: "2" }),
    React.createElement("path", { d: "M15.4738 8.03751C15.7132 8.03627 15.9433 8.12728 16.1135 8.29052C16.2837 8.45376 16.3801 8.67586 16.3815 8.90795L16.4123 14.1587L21.8276 14.1306C22.0669 14.1294 22.297 14.2204 22.4673 14.3836C22.6375 14.5469 22.7339 14.769 22.7352 15.0011C22.7366 15.2332 22.6428 15.4562 22.4745 15.6212C22.3062 15.7862 22.0772 15.8796 21.8378 15.8809L16.4226 15.9089L16.4534 21.1597C16.4547 21.3918 16.361 21.6149 16.1927 21.7799C16.0244 21.9449 15.7953 22.0383 15.556 22.0395C15.3166 22.0407 15.0865 21.9497 14.9163 21.7865C14.7461 21.6232 14.6497 21.4011 14.6483 21.1691L14.6175 15.9183L9.2022 15.9464C8.96283 15.9476 8.73272 15.8566 8.5625 15.6934C8.39227 15.5301 8.29588 15.308 8.29451 15.0759C8.29315 14.8438 8.38694 14.6208 8.55523 14.4558C8.72353 14.2908 8.95255 14.1974 9.19192 14.1961L14.6072 14.1681L14.5764 8.91731C14.575 8.68522 14.6688 8.46213 14.8371 8.29714C15.0054 8.13214 15.2344 8.03875 15.4738 8.03751Z", fill: "#BB2649" })));
const Actions = React.memo(() => {
    const { t } = useTranslation('SearchForm');
    const dispatch = useDispatch();
    const { pauseValidation } = useForm();
    const onAddSegmentHandler = () => {
        dispatch(addSegment());
        pauseValidation();
    };
    return (React.createElement("div", { className: css.container },
        React.createElement(Button, { variant: "text", className: css.button, onClick: onAddSegmentHandler },
            PlusIcon,
            " ",
            t('Add flight'))));
});
export default Actions;
